import React from "react";
import { Tooltip, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

export type ColumnLabelWithTooltipProps = {
  label: string;
  labelStyles?: React.CSSProperties;
  tooltip: string;
};

const useStyles = makeStyles(() => ({
  label: {
    color: "black",
    fontWeight: 500,
  },
  tooltip: {
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

function ColumnLabelWithTooltip({
  label,
  tooltip,
  labelStyles = {},
}: ColumnLabelWithTooltipProps) {
  const classes = useStyles();

  return (
    <Typography variant="body1" style={labelStyles}>
      <Tooltip
        className={classes.tooltip}
        title={tooltip}
        placement="top"
        arrow
      >
        <span className={classes.label}>{label}</span>
      </Tooltip>
    </Typography>
  );
}

export default ColumnLabelWithTooltip;
